import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/agreementsAnalysisSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import FilterDropdown from "./smartComponents/FilterDropdown";
import AgreementsAnalysisTable from "./smartComponents/AgreementsAnalysisTable";
import { DataPoints } from "./smartComponents/DataPoints";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import PieChart from "./smartComponents/PieChart";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import NoData from "../../../components/noData/noData";

const AgreementsAnalysis = (params) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.agreementsAnalysis.isLoading);

  const {
    pieCharts: { category_type = [], membership_type = [] }
  } = useSelector((state) => state.agreementsAnalysis.chartData);

  const updatesLoading = useSelector((state) => state.agreementsAnalysis.updatesLoading);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  return (
    <div id="agreements-analysis-module">
      <SectionToggle
        title="Agreements Analysis"
        isLoading={isLoading}
        autoHeight
        learnMore={
          <KBLearnMore
            title="Agreements Analysis"
            description="This report shows how membership agreements are performing across new signups, renewals, upgrades, and cancellations. These insights help you evaluate agreement trends, identify healthy or at-risk segments, and make informed decisions about membership strategies."
            kbUrl={ILEARN_URLS.agreements.agreementsAnalysis}
          />
        }
        content={
          <div>
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="top-filters">
                <div>
                  <CustomDateRanges />
                  <DatePicker />
                </div>
                <div>
                  <FilterDropdown keyName="agreement_types" label="Agreement Type" />
                  <FilterDropdown
                    keyName="agreement_date"
                    label="Agreement Start"
                    isMultiSelect={false}
                  />
                  <FilterDropdown keyName="membership_types" label="Membership Type" />
                  <FilterDropdown keyName="categories" label="Category" />
                  <FilterDropdown keyName="rejoin_after" label="Rejoin After" isMultiSelect={false} />
                </div>
              </div>
              <UpdateBtns />
            </div>
            {updatesLoading ? (
              <LoadingAnimation text="Updating data..." />
            ) : membership_type.length ? (
              <>
                <div className="charts-wrapper">
                  <DataPoints />
                  <div className="pie-charts">
                    <PieChart chartData={category_type} />
                    <PieChart chartData={membership_type} />
                  </div>
                </div>
                <AgreementsAnalysisTable />
              </>
            ) : (
              <NoData />
            )}
          </div>
        }
      />
    </div>
  );
};

export default AgreementsAnalysis;
